import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useSearchParams } from 'react-router';
import { Button } from '../../../components/ui/button';
import Input from '../../../components/ui/input';
import Breadcrumb from '../../../components/Breadcrumb';
import { PRODUCTMANAGE_PAGE } from '../../../routes/routeConstant';
import { FileUpload } from '../../../components/InputImage';
import InputEn from '../../../components/InputEn';
import useInsurance from '../../../stores/useInsurance';
import { IInsurance } from '../../../types/types';

export default function FormInsurance() {
  const backLink = `${PRODUCTMANAGE_PAGE}?page=Insurance`;
  const breadcrumbPath = [{ name: 'Insurance', link: backLink }, { name: 'Form Insurance' }];
  const { insurances, saveLoading, addInsurance, editInsurance, fetchInsurances } = useInsurance();
  const [searchParams, setSearchParams] = useSearchParams();
  const editId = searchParams.get('edit');
  const [currentImage, setCurrentImage] = useState<string>('/assets/no-data-image.svg');

  const { register, handleSubmit, setValue, reset, watch } = useForm<IInsurance>({
    defaultValues: {
      name_ins: '',
      description_ins_id: '',
      description_ins_en: '',
      logo_ins: '',
    },
  });

  useEffect(() => {
    fetchInsurances();
  }, [fetchInsurances]);

  useEffect(() => {
    if (editId) {
      const insuranceToEdit = insurances?.find((insurance) => insurance.insurance_id === Number(editId));
      if (insuranceToEdit) {
        setValue('name_ins', insuranceToEdit.name_ins);
        setValue('description_ins_id', insuranceToEdit.description_ins_id);
        setValue('description_ins_en', insuranceToEdit.description_ins_en);
        setValue('logo_ins', insuranceToEdit.logo_ins);
        setCurrentImage(insuranceToEdit.logo_ins || '/assets/no-data-image.svg');
      }
    }
  }, [editId, insurances, setValue]);

  const onSubmit = async (data: IInsurance) => {
    const insuranceToEdit = insurances?.find((insurance) => insurance.insurance_id === Number(editId));
    if (editId && insuranceToEdit !== undefined) {
      await editInsurance(Number(editId), data);
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set('tab', 'list');
        return newParams;
      });
    } else {
      await addInsurance(data);
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set('tab', 'list');
        return newParams;
      });
    }
    reset();
    setCurrentImage('/assets/no-data-image.svg');
  };

  return (
    <div className="flex gap-4 flex-col">
      <Breadcrumb paths={breadcrumbPath} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Name <span className="text-red-600">*</span>
            </p>
            <Input {...register('name_ins')} required type="text" placeholder="Nama asuransi.." />
          </div>

          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Description <span className="text-red-600">*</span>
            </p>
            <InputEn
              type="textarea"
              nama="description_ins_id"
              namaEn="description_ins_en"
              placeholder="Masukkan deskripsi auransi..."
              register={register}
              watch={watch}
              setValue={setValue}
            />
          </div>

          <div className="flex flex-col text-sm w-full mt-2 gap-2">
            <p className="flex gap-1">
              Logo <span className="text-red-600">*</span>
            </p>
            <FileUpload setValue={setValue} register={register} imageFieldName="logo_ins" defaultImage={currentImage} />
          </div>
          <div className="flex gap-2">
            <Button variant="secondary" type="button">
              <Link to={backLink}>Batal</Link>
            </Button>
            <Button type="submit" disabled={saveLoading}>
              {saveLoading ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
